export class ServiceRequestStatus {
  newCount?: number;
  inProgressCount?: number;
  completedCount?: number;  
}